'use client';

import { useAuthTransition } from '@/lib/auth/auth-transition';
import styles from './layout.module.css';

export default function AuthLayout({ children }: { children: React.ReactNode }) {
  const { phase } = useAuthTransition();
  const isCollapsing =
    phase === 'collapsing' ||
    phase === 'exiting' ||
    phase === 'navigating' ||
    phase === 'logout-mounting' ||
    phase === 'logout-entering-form';
  const isExiting = phase === 'exiting' || phase === 'navigating' || phase === 'logout-mounting';
  const className = [
    styles.loginPage,
    isCollapsing ? styles['is-collapsing'] : null,
    isExiting ? styles['is-exiting'] : null,
    phase === 'logout-mounting' ? styles['is-logout-mounting'] : null,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={className}>
      <section className={styles.loginContainer}>
        <section className={styles.loginFormSlot}>{children}</section>
      </section>

      <aside className={styles.loginVisual} aria-hidden="true">
        <div className={styles.vector}>
          <img
            src="/web-static/assets/images/pages/auth/vector-1.svg"
            alt="vector"
            className={styles.vector1}
          />
          <img
            src="/web-static/assets/images/pages/auth/vector-2.svg"
            alt="vector"
            className={styles.vector2}
          />
        </div>
        <div className={styles.testimonial}>
          <div className={styles.starRating} aria-hidden="true">
            {Array.from({ length: 5 }).map((_, i) => (
              <img
                key={i}
                aria-hidden="true"
                src="/web-static/assets/images/pages/auth/blue-star.svg"
                alt="blue-star"
              />
            ))}
          </div>

          <div className={styles.reviewFeedback}>
            <h3 className={styles.heading}>
              ”We’ve got projects running over each other, and ChangePlan is showing us things we
              wouldn’t have seen otherwise — that’s where the power is.”
            </h3>
          </div>

          <div className={styles.customer}>
            <p className={styles.customerName}>Connie Longobardi</p>
            <small className={styles.customerRole}>Organizational Change Manager</small>
          </div>
        </div>
      </aside>
    </div>
  );
}
